import React from 'react';
import { Stethoscope, ShieldCheck, HeartPulse, GraduationCap } from 'lucide-react';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      id: 1,
      icon: <HeartPulse size={30} />,
      title: "Korkusuz Muayene",
      desc: "Çocukların dünyasına oyunla giren özel yaklaşım.",
      color: "#4FBDBA"
    },
    
    {
      id: 3,
      icon: <ShieldCheck size={30} />,
      title: "Tam Güven",
      desc: "30 yıllık akademik ve klinik tecrübe.",
      color: "#7ED957"
    },
    {
      id: 4,
      icon: <GraduationCap size={30} />,
      title: "Akademik Çözüm",
      desc: "En güncel cerrahi literatür desteği.",
      color: "#6C5CE7"
    }
  ];

  return (
    <section className="features-wrapper">
      {/* Hareketli ve Belirgin Baloncuklar */}
      <div className="dynamic-bubbles">
        <div className="bubble b-large b-teal"></div>
        <div className="bubble b-med b-orange"></div>
        <div className="bubble b-small b-purple"></div>
        <div className="bubble b-med b-green"></div>
        <div className="bubble b-large b-blue"></div>
      </div>

      <div className="features-main-container">
        <div className="features-title-box">
          <h2 className="title-text">Minik Kalpler İçin <span>Büyük Uzmanlık</span></h2>
          <p className="subtitle-text">Sağlıklı bir gelecek, uzman ellerde başlar.</p>
        </div>

        {/* 4 Kart Yan Yana */}
        <div className="features-compact-grid">
          {features.map((f) => (
            <div key={f.id} className="compact-card" style={{"--accent": f.color}}>
              <div className="card-inner">
                <div className="compact-icon-box">{f.icon}</div>
                <div className="compact-info">
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </div>
              <div className="card-highlight"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;